/** Fallback when a custom accent fails WCAG AA contrast against white (#fff). */
export const DEFAULT_ACCENT = '#2563eb';

function channel(value: number): number {
  const scaled = value / 255;
  return scaled <= 0.03928 ? scaled / 12.92 : ((scaled + 0.055) / 1.055) ** 2.4;
}

function luminance(hex: string): number | null {
  const raw = hex.trim().replace(/^#/, '');
  const full =
    raw.length === 3
      ? raw
          .split('')
          .map((part) => part + part)
          .join('')
      : raw;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;
  const r = Number.parseInt(full.slice(0, 2), 16);
  const g = Number.parseInt(full.slice(2, 4), 16);
  const b = Number.parseInt(full.slice(4, 6), 16);
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
}

/** Contrast ratio of foreground against white (#fff). */
export function contrastOnWhite(hex: string): number | null {
  const lum = luminance(hex);
  if (lum == null) return null;
  return (1.05) / (lum + 0.05);
}

/**
 * Returns the accent if it meets AA (4.5:1) on white text contexts we use,
 * otherwise the default blue. Invalid colors also fall back.
 */
export function safeAccent(hex: string | null | undefined, minimum = 4.5): string {
  if (!hex) return DEFAULT_ACCENT;
  const ratio = contrastOnWhite(hex);
  if (ratio == null || ratio < minimum) return DEFAULT_ACCENT;
  return hex.trim();
}
